import { Component, Input } from '@angular/core';

@Component({
  selector: 'wl-expression-option-dropdown-option',
  template: '',
    standalone: false
})
export class ExpressionOptionDropdownOptionComponent {
  @Input() public label: string = '';
  @Input() public value: string = '';
}
